import React from "react";
import { GRID_INFORMATION } from "../../utils/CONSTANTS";

const GridInformation = () => {
  return (
    <table className="Flagtable">
      <thead>
        <tr>
          <th>Letter</th>
          <th>Question Count</th>
          <th>Topic</th>
        </tr>
      </thead>
      <tbody>
        {GRID_INFORMATION.map((item, index) => (
          <tr key={`info-${index}`}>
            <td>{item.letter}</td>
            <td className="">
              <span>{item.questionCount}</span>
            </td>
            <td>{item.topic}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default GridInformation;
